const INITIAL_STATE = {
  sendEmail: {},
  errors: {},
}
  
const emailReminder = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'SEND_REMINDER':
    return { ...state, ...INITIAL_STATE, sendEmail: action.data }
  case 'SEND_REMINDER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default emailReminder;
  